import { Img, Lightning } from '@lightningjs/sdk'

export default class EpisodeCover extends Lightning.Component {
  static _template() {
    return {
      CoverWrapper: {
        w: 580,
        h: 580,
        CoverImageWrapper: {
          x: 3,
          y: 3,
          w: 580,
          h: 580,
          clipping: true,
          EpisodeCover: { w: 580, h: 580, src: this.bindProp('coverImage') },
        },
      },
    }
  }

  set item(itm) {
    this.tag('EpisodeCover').patch({
      texture: Img(itm).cover(580 / 2, 580 / 2), // todo resize to original
    })
  }
}
